module.exports = __webpack_public_path__ + "img/csv-file-format-extension.fc9d55f0.svg";